require('./insurancesProductBanners.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
const { formatText, getLanguage } = require('core/i18n').i18n;

// @ utils
const { FormattedText } = require('core/i18n').i18n;
const { getPublicSitePathByLanguaje } = require('core/apiURLBuilder');
const { recordCommercialSpaceV2 } = require('utilities/tagging');
const { hasPublicUrl } = require('utilities/commercialAdsHelper');

//@ components
const ProductBanner = require('components/commons/productBanner/productBanner');

// @ constants
const INSURANCES_PRODUCT_BANNERS = require('constants/productBanners/insurancesProductBanners');
const {
    COMMERCIAL_MOBILE_INSURANCE,
    LIFE_INSURANCE_WAFER
} = require('constants/flagBasedFeatures');
const {
    INSURANCE_HOME,
    ROBO_MOVIL,
    INSURANCE_LIFE
} = require('../../../insuranceConstants/insurancesProductBanners')
const {
    COMMERCIAL_ADS_ACTION_EVENT,
    COMMERCIAL_ADS_CLICK_TEALIUM_EVENT,
    COMMERCIAL_WAFER_ADS_EVENT_CATEGORY,
} = require('constants/tagging')

class InsurancesProductBanners extends React.Component {
    constructor(props) {
        super(props);
    }

    buildInsuranceBanners() {
        const {
            hasSimulationStarted,
            immFlagBasedFeatures,
        } = this.props;
        const showRoboMovilBanner = immFlagBasedFeatures.get(COMMERCIAL_MOBILE_INSURANCE);
        const showLifeBanner = immFlagBasedFeatures.get(LIFE_INSURANCE_WAFER);

        return Object.keys(INSURANCES_PRODUCT_BANNERS).reduce((banners, key) => {
            const bannerData = INSURANCES_PRODUCT_BANNERS[key];
            const bannerAdvantages = bannerData.advantages;
            const bannerId = bannerData.id;
            const bannerKey = `insurances-product-banners-${key}`;
            const language = getLanguage();
            const params ={
                lang: language
            }
            const bannerLink = key === INSURANCE_HOME ? formatText(bannerData.link) : getPublicSitePathByLanguaje(bannerData.link,params);
            const bannerSubtitle = bannerData.subtitle;
            const bannerTitle = bannerData.title;
            const sidebarImgUrl = bannerData.sidebarImgUrl;
            const showBanner = (key === INSURANCE_HOME && !hasSimulationStarted) ||
                (key === ROBO_MOVIL && showRoboMovilBanner) ||
                (key === INSURANCE_LIFE && showLifeBanner);
            const taggingParams = {
                categoriaEvento: `${COMMERCIAL_WAFER_ADS_EVENT_CATEGORY}${bannerId}`,
                accionEvento: COMMERCIAL_ADS_ACTION_EVENT,
                tealiumEvent: COMMERCIAL_ADS_CLICK_TEALIUM_EVENT,
            }
            const taggingCustomData = {
                etiquetaEvento: formatText('common-moreInformation'),
                promotion_id: [bannerId],
                promotion_name: [bannerId],
                promotion_creative: [formatText(bannerTitle)],
                promotion_position: [
                    (key === INSURANCE_HOME && !hasSimulationStarted)
                        ? bannerData.promotionPosition
                        : (key === ROBO_MOVIL && showRoboMovilBanner && !hasSimulationStarted)
                            ? bannerData.promotionPosition
                            : (key === INSURANCE_LIFE && showLifeBanner && !hasSimulationStarted)? bannerData.promotionPosition:'1'
                ],
            }
            const handleBannerClick = () => {
                recordCommercialSpaceV2(taggingParams, taggingCustomData);
                if (hasPublicUrl(bannerLink)) {
                    (key === INSURANCE_LIFE || ROBO_MOVIL)  && __CONTACT_CENTER__ ? window.open(bannerLink,"_blank"): window.location.href = bannerLink;
                } else {
                    this.props.history.push(bannerLink);
                }
            }

            if (showBanner) {
                banners.push(
                    <ProductBanner
                        key={bannerKey}
                        id={bannerId}
                        title={bannerTitle}
                        subtitle={bannerSubtitle}
                        advantages={bannerAdvantages}
                        sidebarImgUrl={sidebarImgUrl}
                        hasButton={true}
                        onButtonClickHandle={handleBannerClick}
                    />
                );
            }

            return banners;
        }, []);
    }

    render() {
        const banners = this.buildInsuranceBanners();

        let header;

        if (banners.length > 0) {
            header = (
                <header className="insurances-product-banners__header">
                    <FormattedText value="productBanner-meetInsurances" />
                </header>
            );
        }

        return (
            <section className="insurances-product-banners">
                {header}
                {banners}
            </section>
        )
    }
}

InsurancesProductBanners.propTypes = {
    hasSimulationStarted: PropTypes.bool.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};

module.exports = withRouter(InsurancesProductBanners);
